<template>
    <v-card height="100%">
        <v-card-text style="height: 100%; padding: 0;">
            <div class="chart-container">
                <apexchart :key="chartKey"
                           type="line"
                           height="100%"
                           :options="updatedChartOptions"
                           :series="sortedSeries">
                </apexchart>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import { defineComponent } from 'vue'
    import VueApexCharts from 'vue-apexcharts'

    export default defineComponent({
        components: {
            apexchart: VueApexCharts
        },
        props: ['series', 'categories'],
        watch: {
            series: {
                handler: function () {
                    if (!this.series || this.series.length < 2) return

                    const combined = this.series[0].data.map((value, index) => ({
                        diff: value - (this.series[1].data[index] || 0), // Ensure index exists
                        series0: value,
                        series1: this.series[1].data[index] || 0, // Handle missing values
                        category: this.categories[index] || ''
                    }))

                    // Sort based on the difference (ascending)
                    combined.sort((a, b) => a.diff - b.diff)

                    // Assign sorted data
                    this.sortedSeries = [
                        { name: this.series[0].name, data: combined.map(item => item.series0) },
                        { name: this.series[1].name, data: combined.map(item => item.series1) }
                    ]
                    this.sortedCategories = combined.map(item => item.category)

                    // Debugging logs
                    console.log('sortedSeries:', this.sortedSeries)
                    console.log('sortedCategories:', this.sortedCategories)

                    // Force chart to refresh
                    this.chartKey++
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            updatedChartOptions() {
                return {
                    chart: {
                        type: 'line',
                        toolbar: { show: false }
                    },
                    stroke: { width: [3, 3], opacity: 1 },
                    colors: ['#28a745', '#dc3545'],
                    xaxis: {
                        categories: this.sortedCategories,
                        type: 'category', // Ensure the x-axis uses categories (not continuous scale)
                        labels: {
                            rotate: -75,
                            trim: true,
                            style: { fontSize: '12px' },
                            offsetX: -10, // Adjust horizontally to reduce space between labels
                            offsetY: 0 // Adjust vertically to move labels closer to the axis
                        },
                        tickPlacement: 'on', // Ensures ticks appear on category positions (reduces space)
                        min: 0,  // Control minimum value (can adjust to fit categories better)
                        max: this.sortedCategories.length + 1, // Adjust max to fit the exact number of categories
                        tickAmount: this.sortedCategories.length, // Limit the number of ticks to match the categories
                        padding: {
                            left: 0,
                            right: 0 // Remove additional space on the edges
                        }
                    },
                    yaxis: { min: 40, max: 85 },
                    tooltip: { theme: 'dark' },
                    legend: {
                        position: 'top',
                        labels: { colors: '#333' }
                    },
                    dataLabels: {
                        enabled: true,
                        style: { fontSize: '12px', colors: ['#000'] },
                        formatter: val => `${val.toFixed(0)}%`,
                        offsetY: -5
                    }
                }
            }




        },
        data() {
            return {
                sortedSeries: [],
                sortedCategories: [],
                chartKey: 0 // Used to force re-render when data updates
            }
        }
    })
</script>

<style scoped>
    .chart-container {
        height: 500px;
        width: 100%;
        overflow: visible; /* Prevent text cutoff */
    }
</style>
